<template>
    <aside>
        <header class="mb-3 d-flex">
            <search-input v-model="search" class="flex-grow-1"/>

            <b-button
                :to="{ name: 'groups.create' }"
                :title="$t('Create new group')"
                variant="primary"
                class="ml-3"
            >
                <fa icon="plus" :title="$t('Create new group')"/>
            </b-button>
        </header>

        <nav>
            <b-list-group tag="ul">
                <b-list-group-item
                    v-for="group in items"
                    :key="group.id"
                    class="justify-between"
                    tag="li"
                >
                    <b-link
                        :to="{ name: 'groups.edit', params: { id: group.id } }"
                        class="flex-grow-1"
                    >
                        <div class="d-flex w-100 justify-content-between">
                            <h2 class="h5 mb-1">
                                {{ group.name }}
                            </h2>
                        </div>

                        <small class="d-block">
                            {{ group.short_name }}
                        </small>
                    </b-link>

                    <list-item-buttons
                        :api-url="apiUrl"
                        :item="group"
                        no-duplicate
                        @deleted="handleDeleted($event.id)"
                    />
                </b-list-group-item>
            </b-list-group>
        </nav>

        <b-pagination
            v-if="showPagination"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            limit="3"
        />

        <b-alert :show="!pending && !items.length" variant="warning">
            {{ $t('To create a new group use the plus button') }}
        </b-alert>

        <div v-show="pending" class="text-center mt-1">
            <b-spinner/>
        </div>
    </aside>
</template>
<script>
    import fetchPaginatedData from '@/mixins/fetchPaginatedData';
    import SearchInput from "@/components/SeachInput";
    import crudListener from "@/mixins/crudListener";
    import ListItemButtons from "@/components/ListItemButtons";

    export default {
        name: 'Groups',
        components: {ListItemButtons, SearchInput},
        mixins: [fetchPaginatedData, crudListener],
        computed: {
            apiUrl() {
                return '/api/groups'
            },

            resourceName() {
                return 'groups';
            },
        },
    };
</script>
